import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetFooterParams } from "../interface";
import FooterMargauxMotin from "design-system/src/Components/WidgetPart/LandingFooter/FooterMargauxMotin/FooterMargauxMotin";

const FooterMargauxMotinTemplate: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetFooterParams>((props) => {
    const { p } = props;

    return (
      <FooterMargauxMotin
        logoLink={"/"}
        title={p("share_title") || ""}
        socialNetworkLabel={p("social_text")}
        socialLinks={{
          facebook: p("facebook_link"),
          instagram: p("instagram_link"),
          pinterest: p("pinterest_link"),
          // twitter: p("twitter_link"),
          tiktok: p("tiktok_link"),
        }}
        footerText={p("footer_text")}
      />
    );
  });

export default FooterMargauxMotinTemplate;
